export default {
	methods: {
		getProcessPedidoUtilizacao() {
			const pedidoUtilizacao = this.$store.state.loki.bpm.process['Process_PedidoUtilizacao']

			if (pedidoUtilizacao && pedidoUtilizacao[this.idPedido]) {
				return this.$store.state.loki.bpm.process['Process_PedidoUtilizacao'][this.idPedido]
			}
		},
		isPermissaoAutorizada(permissao) {
			const process = this.getProcessPedidoUtilizacao()
			if (process && process.currentTask) {
				const partes = process.currentTask.revokedPermissions.split(',')
				for (const parte of partes) {
					if (parte.includes(permissao)) {
						return false
					}
				}
			}
			return true
		},
	},
}
